import { Component, Vue } from 'vue-property-decorator';
import { every, isEmpty, isString } from 'lodash-es';
import * as qs from 'qs';
import { TMSCustomerAccountService } from '../../services/user';
import tmsService from '../../services/axios/tmsService';
import tmsTransformRequestService from '../../services/axios/tmsTransformRequestService';
import { LocalStorageCache } from '../../services/cache';
import { analytics } from '../../services/analytics';

function isNotNullValue(query_param: any): boolean {
    return isString(query_param) && !isEmpty(query_param);
}

function getCustomerAccount() {
    return new Promise((resolve, reject) => {
        TMSCustomerAccountService.create({
            cache: LocalStorageCache.create(),
            tmsService: tmsService,
            tmsTransformRequestService: tmsTransformRequestService,
        })
            .fetchThenCacheCustomerAccount()
            .then(() => {
                resolve('success');
            })
            .catch(() => {
                reject(new Error('get_customer_account err'));
            });
    });
}

function fetchAnalyticsUserContext() {
    return tmsService
        .post(
            'write_new/check_user.php',
            qs.stringify({ in_iframe: false, pageName: 'dashboard' })
        )
        .then(response => analytics.setUserContext(response.data))
        .catch(error => {
            console.error('Unable to load analytics user context', error);
        });
}

@Component({
    components: {},
})
class ClientSsoLogin extends Vue {
    name = 'hello';

    mounted() {
        const query = this.$route.query;

        const user_id = query.user_id as any;
        const user_token = query.user_token as any;
        const user_first_last = query.user_first_last as any;
        const company_id = query.company_id as any;

        const is_user_guide_done = query.is_user_guide_done as any;
        const is_business_type_set = query.is_business_type_set as any;

        const required = [user_id, user_token, user_first_last, company_id];

        console.log(every(required, i => !isNotNullValue(i)));

        if (every(required, i => isNotNullValue(i))) {
            localStorage.setItem('UserID', user_id);
            localStorage.setItem('UserFirstLast', user_first_last);
            localStorage.setItem('UserToken', user_token);
            localStorage.setItem('company_id', company_id);
        }

        localStorage.setItem(
            'is_user_guide_done',
            isNotNullValue(is_user_guide_done) ? is_user_guide_done : 'false'
        );
        localStorage.setItem(
            'is_business_type_set',
            isNotNullValue(is_business_type_set) ? is_business_type_set : 'false'
        );

        if (isNotNullValue(user_id) && isNotNullValue(user_token)) {
            getCustomerAccount()
                .then(() => fetchAnalyticsUserContext())
                .then(() => {
                    analytics.queueEvent('login', { method: 'sso' });
                    analytics.flushPendingEvents();
                    // redirect
                    this.$router.push('/home');
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }
}

export default ClientSsoLogin;



// WEBPACK FOOTER //
// ./src/layouts/client-sso-login/client-sso-login.ts